module.exports = __webpack_public_path__ + "img/ALIPAY.png?4515fd6e80934ea5783c2799c707474b";